import {
  Avatar,
  Breadcrumb,
  Button,
  // Card,
  Col,
  Dropdown,
  Image,
  Row,
  Tabs,
  TabsProps,
  Tag,
} from "antd";
import {
  AngleRight,
  ContractsIcon,
  DeleteIcon,
  NeedHelp,
  // PdfIcon,
  // PlusIcon,
  // SearchIcon,
} from "../../../atoms/CustomIcons";
import DashboardTemplate from "../../../templates/Dashboard";
import Dashboard from "./ProfileTabs/Dashboard";
import Deals from "./ProfileTabs/Deals";
import Tasks from "./ProfileTabs/Tasks";
import Schedule from "./ProfileTabs/Schedule";
import WorkOrders from "./ProfileTabs/WorkOrders";
// import TakeOff from "./ProfileTabs/TakeOff";
import Invoices from "./ProfileTabs/Invoices";
// import ProfileSidebar from "./Components/Sidebar";
import { useState } from "react";
import { MoreOutlined } from "@ant-design/icons";
import TakeOffStatic from "./ProfileTabs/TakeOffStatic";
import DummyData from "../property-data.json";
import PreferredVisitPopup from "./Components/PreferredVisitPopup";
import { PopUp } from "../../../atoms/PopUp";
import ProfileSidebar from "./Components/Sidebar";

export default function PropertyProfile() {
  const [fullWidth, setFullWidth] = useState(false);
  const [PreferredVisitTime, setPreferredVisitTime] = useState<boolean>(false);
  const [loading] = useState(false);

  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const propertyId = pathSegments[pathSegments.length - 2];
  const companyId = pathSegments[pathSegments.length - 1];

  let dummyData = DummyData.find((x) => x.id === propertyId);

  if (!dummyData) {
    dummyData = DummyData[0];
  }
  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Dashboard",
      children: <Dashboard data={dummyData.property.dashboard} />,
    },
    {
      key: "2",
      label: "Deals",
      children: <Deals data={dummyData?.property.deals} />,
    },
    {
      key: "3",
      label: "Work orders",
      children: <WorkOrders data={dummyData?.property.workOrders} />,
    },
    {
      key: "4",
      label: "Tasks",
      children: <Tasks data={dummyData?.property.tasks} />,
    },
    {
      key: "5",
      label: "Schedule",
      children: <Schedule />,
    },
    {
      key: "6",
      label: "Takeoff",
      children: <TakeOffStatic />,
    },
    {
      key: "7",
      label: "Invoices",
      children: <Invoices />,
      disabled: true,
    },
  ];

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/save-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          New deal
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/change-user.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Change account responsible
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/reset-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Transfer to another client
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "5",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/archive-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Archive
        </Button>
      ),
    },
    {
      key: "6",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const deleteFunction = () => {
    console.log("Delete clicked ");
  };

  const PreferredVisit = {
    visibility: PreferredVisitTime,
    class: "upload_photo_modal",
    content: (
      <PreferredVisitPopup
        title=""
        onClose={() => setPreferredVisitTime(false)}
        heading="Delete photo"
        paragraph="Delete your profile photo?"
        btnText="Delete photo"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setPreferredVisitTime(false),
  };

  return (
    <>
      <DashboardTemplate loading={false}>
        <div className="profileHeader">
          <div className="headerLeft">
            <Breadcrumb
              separator={<AngleRight />}
              style={{ marginBottom: "12px" }}
            >
              <Breadcrumb.Item>
                <a href={`/properties/${companyId}`}> Properties </a>
              </Breadcrumb.Item>

              <Breadcrumb.Item>Property profile</Breadcrumb.Item>
            </Breadcrumb>

            <div className="headerContentWithImage">
              <Avatar
                size={74}
                className="avatarColor"
                shape="square"
                src={dummyData.property.image}
                style={{ borderRadius: "100px" }}
              />

              <div>
                <h2
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "8px",
                    marginBottom: "8px",
                  }}
                >
                  {dummyData.property.name}
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                  >
                    {dummyData.property.category?.map(
                      (x: { name: string; color: string }) => {
                        return <Tag className={x.color}> {x.name} </Tag>;
                      }
                    )}
                  </span>
                </h2>

                <div
                  style={{ display: "flex", gap: "16px", alignItems: "center" }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      src="/images/estimate/clients-icon.svg"
                      style={{ width: "16px", height: "16px" }}
                      preview={false}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "400",
                        color: "#474C4D",
                      }}
                    >
                      {dummyData.property.client_name}
                    </span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <Image
                      src="/images/estimate/pin_location.svg"
                      style={{ width: "16px", height: "16px" }}
                      preview={false}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "400",
                        color: "#474C4D",
                      }}
                    >
                      {dummyData.property.address}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="two_btns">
            <Button htmlType="submit" size="large" className="btn-sm">
              <NeedHelp /> Need help?
            </Button>
          </div>
        </div>

        <div
          className="headerRight"
          style={{ marginTop: "55px", marginRight: "37px" }}
        >
          <Button
            htmlType="button"
            type="default"
            size="large"
            className="outlined-btn"
            style={{ marginRight: "8px" }}
          >
            Notes & activity
          </Button>

          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            placement="bottomRight"
            className="actionButton"
          >
            <Button
              onClick={(x) => {
                x.stopPropagation();
              }}
              onKeyDown={(e) => e.stopPropagation()}
              style={{
                padding: "0px",
                height: "36px",
                width: "36px",
                backgroundColor: "transparent",
                border: "1px solid #DEE5E6",
                borderRadius: "8px",
              }}
              className="only_icon"
              icon={<MoreOutlined />}
            />
          </Dropdown>
        </div>

        <div className="profileContent">
          <Row gutter={[16, 16]} wrap={false}>
            <Col flex="auto" className="TabsArea">
              <Tabs
                defaultActiveKey="1"
                items={tabItems}
                className="profileTabs"
                tabBarExtraContent={
                  <Button
                    className="only_icon"
                    style={{ marginLeft: 8 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setTimeout(
                        () => {
                          setFullWidth(!fullWidth);
                        },
                        fullWidth ? 100 : 0
                      );
                    }}
                    icon={
                      <Image
                        preview={false}
                        src="/images/profile/profile-fullWidth.svg"
                      />
                    }
                  />
                }
              />
            </Col>
            <Col
              flex={fullWidth ? "46px" : "360px"}
              className="rightSideBar"
              style={{ transition: "0.35s" }}
            >
              {fullWidth ? (
                <div className="fullWidthIconWrapper">
                  <Button
                    className="only_icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      setTimeout(
                        () => {
                          setFullWidth(!fullWidth);
                        },
                        fullWidth ? 100 : 0
                      );
                    }}
                    icon={<ContractsIcon />}
                  />
                </div>
              ) : (
                <ProfileSidebar
                  data={{
                    notes: dummyData?.property?.noteForCrew,
                    documents: dummyData?.property?.documents.folders,
                    preferredVisitTime: dummyData?.property?.preferredVisitTime,
                  }}
                />
                // <div className="notes_activity_sidebar">
                //   <div className="header_bar">
                //     <div>
                //       <h3> Activity history </h3>
                //     </div>
                //     <div className="head_icon">
                //       <SearchIcon />
                //       <PlusIcon />
                //     </div>
                //   </div>
                //   <div className="content_bar">
                //     <Card className="activity_card grey_client_card">
                //       <div className="profile_avatar">
                //         <Avatar
                //           size={32}
                //           shape="square"
                //           src="/images/dummy/checkList_dp_2.png"
                //           className="profile_image"
                //         />

                //         <div>
                //           <h2 className="profile_name">
                //             Jasper A. attached 2 files
                //           </h2>
                //           <h5 className="profile_role">Operations Manager</h5>
                //         </div>
                //       </div>

                //       <div className="activity_time">
                //         <p>12:00 PM</p>
                //       </div>

                //       <div className="activity_content">
                //         <ul>
                //           <li
                //             onClick={() => setPreferredVisitTime(true)}
                //             style={{ cursor: "pointer" }}
                //           >
                //             <span className="fileType">
                //               <PdfIcon />
                //             </span>
                //             Leadership results.pdf
                //           </li>
                //           <li
                //             onClick={() => setPreferredVisitTime(true)}
                //             style={{ cursor: "pointer" }}
                //           >
                //             <span className="fileType">
                //               <PdfIcon />
                //             </span>
                //             Leadership results.doc
                //           </li>
                //         </ul>
                //       </div>
                //     </Card>
                //     <Card className="activity_card blue_me_card">
                //       <div className="profile_avatar">
                //         <Avatar
                //           size={32}
                //           shape="square"
                //           src="/images/dummy/checkList_dp_3.svg"
                //           className="profile_image"
                //         />

                //         <div>
                //           <h2 className="profile_name">
                //             Anna L. <span className="me_tag">(me)</span>
                //           </h2>
                //           <h5 className="profile_role">Operations Manager</h5>
                //         </div>
                //       </div>

                //       <div className="activity_time">
                //         <p>11:00 PM</p>
                //       </div>

                //       <div className="activity_content">
                //         <p>
                //           Please trim along the fence and check irrigation
                //           timing. Thanks!
                //         </p>
                //       </div>
                //     </Card>
                //     <Card className="activity_card grey_client_card">
                //       <div className="profile_avatar">
                //         <Avatar
                //           size={32}
                //           shape="square"
                //           src="/images/dummy/checkList_dp_2.png"
                //           className="profile_image"
                //         />

                //         <div>
                //           <h2 className="profile_name">Jasper A.</h2>
                //           <h5 className="profile_role">Operations Manager</h5>
                //         </div>
                //       </div>

                //       <div className="activity_time">
                //         <p>12:00 PM</p>
                //       </div>

                //       <div className="activity_content">
                //         <p className="grey_text">
                //           Hi Jack, <br /> I hope you're doing well. Please find
                //           attached...
                //         </p>
                //       </div>
                //     </Card>
                //     <Card className="activity_card transparent_card">
                //       <div className="profile_avatar">
                //         <div>
                //           <h2 className="profile_name">
                //             <b>Michael S.</b> updated{" "}
                //             <a href="www.google.com">
                //               {" "}
                //               Proposal v.3 - 03.10.2025{" "}
                //             </a>
                //             status from
                //           </h2>
                //         </div>
                //       </div>

                //       <div className="activity_time">
                //         <p>09:00 PM</p>
                //       </div>

                //       <div style={{ display: "flex", gap: "8px" }}>
                //         <Tag className="approval_pending_tag">Inprogress</Tag>
                //         to <Tag className="sent_tag">Sent</Tag>
                //       </div>
                //     </Card>
                //   </div>
                // </div>
              )}
            </Col>
          </Row>
        </div>
      </DashboardTemplate>

      <PopUp {...PreferredVisit} />
    </>
  );
}
